<template>
  <div style="background-color: yellowgreen" class="webmain">
    <div class="footer">
      <div class="content">
        <el-row :gutter="20">
<!--          <el-col :span="6" class="hidden-md-and-down" >-->
<!--            <div class="fabout">-->
<!--              <div class="flogo">-->
<!--              </div>-->
<!--              <div class="nr">中科智充核心专家由浙江大学电气学院博导，中科院合肥物质研究院硕博团队、高级工程师等高层次人才团队领衔。</div>-->
<!--            </div>-->
<!--          </el-col>-->
          <el-col  :span="8" >
            <div class="kslink">
              <div class="lmtit">快速链接</div>
              <div class="nr">
                <a href="/about">关于我们</a>
                <a href="/production">产品中心</a>
                <a href="/commercial">招商加盟</a>
                <a href="http://admin.casmrc.cn">管理后台</a>
                <a href="/news">新闻中心</a>
                <a href="/">首页</a>
                <div class="clean"></div>
              </div>
            </div>
          </el-col>
          <el-col :span="8" :xs="24" :sm="12" :md="8" :lg="8">
            <div class="ewm" >
              <div class="lmtit">通讯地址</div>
              <div class="nr">
                <i class="el-icon-phone"></i>   400-8355-708 <br/>
                <i class="el-icon-location-information"></i>    合肥市高新区习友路2666号中科院合肥技术创新工程院研发楼6层
              </div>
            </div>
          </el-col>
          <el-col :span="8" :xs="24" :sm="12" :md="8" :lg="8">
            <div class="ewm">
              <div class="lmtit">联系我们</div>
              <div class="pic"><el-image :preview-src-list="code1" :src="require('../../assets/images/footer/QR_mini.png')" /></div>
              <div class="pic"><el-image :preview-src-list="code2" :src="require('../../assets/images/footer/QR_wx.jpg')" /></div>
            </div>
          </el-col>
        </el-row>
      </div >
    </div>
    <div class="banq">
      <div class="content">
        Copyright © 2019-{{date|dateToYear(date)}} 安徽中科智充新能源科技有限公司 版权所有  皖ICP备19007473号-1 技术支持：<a href="#">中科智充</a>
      </div>
    </div>

  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "Contact",
  data(){
    return{
      date:new Date(),
      code1:[
        require('@/assets/images/footer/QR_mini.png')
      ],
      code2:[
        require('@/assets/images/footer/QR_wx.jpg')
      ]
    }
  },
  filters:{
    dateToYear(date){
      return moment(date).format("YYYY")
    }
  }
}
</script>

<style lang="less" scoped>

@import url(../../assets/css/style.css);
@import url(../../assets/css/reset.css);
@import url(../../assets/css/media.css);
.footer{ padding: 30px 0; background: #2c2c2c; color: #fff;}
.footer a{ color: #fff; }
.footer .lmtit{ font-size: 18px; margin-bottom: 20px; }
.footer .fabout{ width: 250px; margin-right: 150px; }
.footer .fabout .flogo{ margin-bottom: 20px; }
.footer .fabout .nr{ line-height: 30px; font-size: 14px; }
.footer .kslink{ width: 180px; margin-right: 70px; }
.footer .kslink .nr a{
  display: block; line-height: 30px; width: 50%; float: left;
  &:hover{
    color: #2c6bb6;
  }
}

.footer .fcon{
  width: 220px;
  .nr{
    line-height: 30px;
    font-size: 14px;
    i{
      font-size: 18px;
      width: 18px;
      text-align: center;
    }
  }
}

.footer .ewm{
  width: 240px;
  .pic{
    float: left;
    margin: 5px 5px;
    .el-image{
      width: 110px;
      height: 110px;
    }
  }
}
.banq{ line-height: 22px; padding: 10px 0; background: #333333; text-align: center; color: #eee; }
.banq a{ color: #fff; }
</style>
